import { render } from "./manageForm.vue?vue&type=template&id=24581a86&scoped=true"
import script from "./manageForm.vue?vue&type=script&lang=js"
export * from "./manageForm.vue?vue&type=script&lang=js"

import "./manageForm.vue?vue&type=style&index=0&id=24581a86&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24581a86"]])

export default __exports__